(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.bkiInit) return;
    root.dataset.bkiInit = '1';
    var track = root.querySelector('[data-bki-track]');
    var nav = root.querySelector('[data-bki-nav]');
    var prev = root.querySelector('[data-bki-prev]');
    var next = root.querySelector('[data-bki-next]');
    root.querySelectorAll('.bki__more').forEach(function (m) {
      m.addEventListener('click', function () {
        var card = m.closest('.bki__card');
        var open = card.classList.toggle('is-open');
        m.textContent = open ? (m.getAttribute('data-less') || m.getAttribute('data-more')) : m.getAttribute('data-more');
        m.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    if (!track || !nav) return;
    function step() {
      var c = track.querySelector('.bki__card');
      if (!c) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return c.getBoundingClientRect().width + gap;
    }
    var raf = 0;
    function update() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    function queue() { if (!raf) raf = requestAnimationFrame(update); }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(track);
    update();
  }
  function run(scope) { (scope || document).querySelectorAll('[data-bki]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(wrap) {
    if (wrap.dataset.bkInit) return;
    wrap.dataset.bkInit = '1';
    var items = wrap.querySelectorAll('.bk-rslide__item');
    var dots = wrap.querySelectorAll('.bk-rslide__dot');
    if (items.length < 2) return;
    var ms = parseInt(wrap.dataset.interval, 10) || 2000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0, timer = null, hover = false, focus = false, visible = true;
    function show(n) {
      cur = (n + items.length) % items.length;
      items.forEach(function (it, i) {
        var on = i === cur;
        it.classList.toggle('is-active', on);
        if (on) it.removeAttribute('aria-hidden'); else it.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, i) { if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      var next = items[(cur + 1) % items.length].querySelector('img');
      if (next && next.loading === 'lazy') next.loading = 'eager';
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (reduce || hover || focus || !visible || document.hidden) return;
      timer = setInterval(function () { show(cur + 1); }, ms);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); play(); }); });
    wrap.addEventListener('mouseenter', function () { hover = true; stop(); });
    wrap.addEventListener('mouseleave', function () { hover = false; play(); });
    wrap.addEventListener('focusin', function () { focus = true; stop(); });
    wrap.addEventListener('focusout', function () { focus = false; play(); });
    document.addEventListener('visibilitychange', play);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; play(); }, { threshold: 0.2 }).observe(wrap);
    } else { play(); }
  }
  function run(root) { (root || document).querySelectorAll('[data-bk-rslide]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
